import { OrderShipment } from './order-shipment';
import { LineStatus } from './enums';

export class OrderShipmentGroup {
  status: LineStatus;
  orderShipments: OrderShipment[];
}
